module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_strengths_img_sp-a8dcc892623c75d6d8bb782c7a82569f.jpg";